export default "__VITE_ASSET__DQdrKmAy__"